import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IGridMode } from "./models";

const initialState: IGridMode = {
  gridMode:
    localStorage.getItem("Verwimp.catalog.grid-mode") === "grid"
      ? "grid"
      : "list",
};

export default function gridModeReducer(
  state: IGridMode,
  action: Action,
): IGridMode {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const data = (action as PayloadAction<IGridMode>).payload;
      return { ...data };
    }
    default:
      return state;
  }
}
